if (!customElements.get('scroll-steps-section')) {
  customElements.define(
    'scroll-steps-section',
    class ScrollStepsSection extends HTMLElement {
      constructor() {
        super();
        this.panels = this.querySelectorAll('[data-step]');
        this.triggers = this.querySelectorAll('[data-step-trigger]');
        this.videos = this.querySelectorAll('video');
      }

      connectedCallback() {
        // Only needed on desktop where the sticky column is active
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.setupObserver();
        this.mediaQuery.addEventListener('change', () => this.setupObserver());

        // Play videos once they're actually in view (saves battery/bandwidth)
        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        this.videos.forEach((video) => this.videoObserver.observe(video));
      }

      setupObserver() {
        if (this.stepObserver) this.stepObserver.disconnect();
        if (!this.mediaQuery.matches) return; // desktop only

        this.stepObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const step = entry.target.dataset.stepTrigger;
              this.setActiveStep(step);
            });
          },
          {
            // Fires when a text block crosses the vertical center of the viewport
            rootMargin: '-45% 0px -45% 0px',
            threshold: 0,
          }
        );

        this.triggers.forEach((trigger) => this.stepObserver.observe(trigger));
      }

      setActiveStep(step) {
  this.panels.forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.step === step);
  });
}

      disconnectedCallback() {
        if (this.stepObserver) this.stepObserver.disconnect();
        if (this.videoObserver) this.videoObserver.disconnect();
      }
    }
  );
}
